import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input, output, TemplateRef } from '@angular/core';
import { SvgIconComponent } from '../../../../../../components/svg-icon/svg-icon.component';

@Component({
    selector: 'setup-node',
    imports: [CommonModule, SvgIconComponent],
    templateUrl: './setup-node.component.html',
    styleUrl: './setup-node.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SetupNodeComponent {
  allowEdit = input<boolean>();
  editing = input<boolean>();
  hovering = output<boolean>();

  @Input() displayTemplate!: TemplateRef<any>;
  @Input() editTemplate!: TemplateRef<any>;

  constructor() {}
}
